import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Lead } from '../types';
import { CallIcon } from './BrandIcons';

interface CallModalProps {
  lead: Lead;
  onClose: () => void;
}

/** Calls are placed from the operator's phone. The Nurture app on that phone
 *  observes the call and attaches its recording to the lead — the portal never
 *  logs a call itself, or the same dial would land twice. */
const CallModal: React.FC<CallModalProps> = ({ lead, onClose }) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    if (!lead.mobile) return;
    navigator.clipboard.writeText(lead.mobile).then(() => setCopied(true));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-charcoal/30" />
      <div
        className="relative bg-warm-white rounded-lg border-[1.5px] border-sketch shadow-sketch-lg w-full max-w-md mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-charcoal font-display text-xl m-0">Call {lead.name}</h3>
          <button onClick={onClose} className="p-1 hover:bg-cream rounded-lg transition-colors" aria-label="Close">
            <X className="w-5 h-5 text-graphite" strokeWidth={1.75} />
          </button>
        </div>

        {lead.mobile ? (
          <>
            <div className="flex items-center gap-3">
              <CallIcon className="w-10 h-10 flex-none" />
              <span className="num font-display text-2xl font-semibold select-all">{lead.mobile}</span>
            </div>
            <p className="text-graphite text-[13px] mt-3 mb-5">
              Dial from your phone. Nurture records the call and attaches the recording to the lead on its own.
            </p>
            <div className="flex gap-2">
              <button className="btn btn-pri" onClick={copy}>{copied ? 'Copied' : 'Copy number'}</button>
              <a className="btn" href={`tel:${lead.mobile}`}>Open dialer</a>
            </div>
          </>
        ) : (
          <p className="text-graphite text-sm">No phone number on file.</p>
        )}
      </div>
    </div>
  );
};

export default CallModal;
